import { Component, OnDestroy, OnInit } from "@angular/core";
import { FuseTranslationLoaderService } from "@fuse/services/translation-loader.service";
import { locale as english } from "./i18n/en";
import { locale as spanish } from "./i18n/es";

import { FuseSidebarService } from "@fuse/components/sidebar/sidebar.service";

import { MatDialog } from "@angular/material/dialog";
import { DialogAgregarServicioComponent } from "./components/dialog-agregar-servicio/dialog-agregar-servicio.component";
import { DialogAgregarServicioComplementarioComponent } from "./components/dialog-agregar-servicio-complementario/dialog-agregar-servicio-complementario.component";
import { CategoriaDTO } from "../../shared/interfaces/categoria.interface";
import { FuseProgressBarService } from "@fuse/components/progress-bar/progress-bar.service";
import { catchError, finalize, map } from "rxjs/operators";

import { ServicioSeleccionado } from "../../shared/models/servicio-seleccionado.model";
import { ServicioComplementario } from "../../shared/models/servicio-complementario.model";
import { DetalleServicioSeleccionado } from "../../shared/models/detalle-servicio-seleccionado.model";
import { UsuarioService } from "../../shared/services/rest/usuario.service";
import { SucursalPersonaDTO } from "../../shared/interfaces/sucursal-persona.interface";

import { TotalServicios } from "../../shared/models/total-servicios.model";
import { of, Subscription } from "rxjs";
import { CatalogoService } from "../../shared/services/rest/catalogo.service";
import { ServicioDTO } from "../../shared/interfaces/servicio.interface";
import { ServicioSolicitadoDTO } from "../../shared/models/servicio-solicitado.model";
import { CotizacionesService } from "../../shared/services/rest/cotizaciones.service";
import { NotificacionesService } from "../../shared/services/rest/notificaciones.service";
import { Router } from "@angular/router";
import { HttpErrorResponse, HttpEventType } from "@angular/common/http";

@Component({
    selector: "app-cotizar",
    templateUrl: "./cotizar.component.html",
    styleUrls: ["./cotizar.component.scss"],
})
export class CotizarComponent implements OnInit, OnDestroy {
    categorias: CategoriaDTO[];
    sucursales: SucursalPersonaDTO[];
    serviciosSeleccionados: ServicioSeleccionado[] = [];
    serviciosComplementarios: {
        servicios: ServicioComplementario[];
        archivos: File[];
    } = { servicios: [], archivos: [] };
    total: TotalServicios;
    subscripciones: Subscription;
    cargandoCategorias: boolean;
    procesando:boolean=false;
    constructor(
        private _fuseTranslationLoaderService: FuseTranslationLoaderService,
        private _fuseSidebarService: FuseSidebarService,
        private _catalogoSrvc: CatalogoService,
        private _usuarioSrvc: UsuarioService,
        private _fuseProgressBarService: FuseProgressBarService,
        private _cotizacionesSrvc: CotizacionesService,
        private _notificacionesSrvc: NotificacionesService,
        public dialog: MatDialog,
        private router: Router
    ) {
        this.cargandoCategorias = true;
        this.subscripciones = new Subscription();
        this._fuseTranslationLoaderService.loadTranslations(english, spanish);
        this.total = new TotalServicios(0, 0, 0, 0);
    }

    ngOnInit(): void {
        this._fuseProgressBarService.show();
        this.subscripciones.add(
            this._catalogoSrvc
                .fetchCatalogoServicios()
                .pipe(
                    finalize(() => {
                        this._fuseProgressBarService.hide();
                        this.cargandoCategorias = false;
                    })
                )
                .subscribe((resp) => {
                    //console.log(resp);
                    this.categorias = resp;
                })
        );

        this.subscripciones.add(
            this._usuarioSrvc
                .fetchSucursalesPersona()
                .subscribe((data) => (this.sucursales = data))
        );
    }
    toggleSidebar(name): void {
        this._fuseSidebarService.getSidebar(name).toggleOpen();
    }

    buscarServiciosPorCategoria(event: CategoriaDTO) {
        this._fuseProgressBarService.show();
        this.subscripciones.add(
            this._catalogoSrvc
                .fetchServiciosPorGrupo(event.id)
                .pipe(finalize(() => this._fuseProgressBarService.hide()))
                .subscribe((resp) =>
                    this._catalogoSrvc.onServiciosChanged.next(resp)
                )
        );
    }

    agregarServicio(servicio: ServicioDTO, result: any) {
        //console.log(servicio, result);
        const sucursal = this.getSucursal(servicio.sucursalSeleccionada);
        servicio.nombreSucursal = this.armaNombreSucursal(sucursal);
        const { cantidad, condicion, observacion, tiempo } = result;
        const detalleServicioSeleccionado = new DetalleServicioSeleccionado(
            cantidad,
            condicion,
            observacion,
            tiempo
        );
        const servicioSeleccionado = new ServicioSeleccionado(
            { ...servicio },
            detalleServicioSeleccionado
        );

        this.serviciosSeleccionados.push(servicioSeleccionado);
        this.calculaTotalServicios();
    }

    calculaTotalServicios() {
        let totalMinUF = 0;
        let totalMaxUF = 0;
        let totalMinCLP = 0;
        let totalMaxCLP = 0;
        this.serviciosSeleccionados.forEach((servicioSeleccionado) => {
            totalMinUF +=
                servicioSeleccionado.servicio.precio.valorMinimoUf *
                servicioSeleccionado.detalle.cantidad;

            totalMinCLP +=
                servicioSeleccionado.servicio.precio.valorMinimoClp *
                servicioSeleccionado.detalle.cantidad;

            totalMaxUF +=
                servicioSeleccionado.servicio.precio.valorMaximoUf *
                servicioSeleccionado.detalle.cantidad;

            totalMaxCLP +=
                servicioSeleccionado.servicio.precio.valorMaximoClp *
                servicioSeleccionado.detalle.cantidad;
        });
        this.total = new TotalServicios(
            totalMinUF,
            totalMaxUF,
            totalMinCLP,
            totalMaxCLP
        );
    }

    openDialogAgregarServicio(
        servicio: ServicioDTO,
        editar = false,
        detalle: DetalleServicioSeleccionado
    ) {
        const dialogRef = this.dialog.open(DialogAgregarServicioComponent, {
            panelClass: "clase-dialog",
            data: {
                servicio,
                editar,
                detalle,
            },
            width: "600px",
        });

        dialogRef.afterClosed().subscribe((result) => {
            //console.log(`Dialog result: ${result}`);
            if (result) {
                if (!editar) {
                    if (
                        !this.servicioDuplicado(
                            servicio.id,
                            servicio.sucursalSeleccionada
                        )
                    ) {
                        this.agregarServicio(servicio, result);
                    } else {
                        //console.log("servicio duplicado");
                    }
                } else {
                    const data = {
                        idServicio: servicio.id,
                        idSucursal: servicio.sucursalSeleccionada,
                    };
                    this.quitarServicio(data);
                    this.agregarServicio(servicio, result);
                }
            }
        });
    }
    quitarServicio(event) {
        const idSucursal = event.idSucursal;
        const idServicio = event.idServicio;
        this.serviciosSeleccionados = this.serviciosSeleccionados.filter(
            (servicioSeleccionado) =>
                servicioSeleccionado.servicio.id !== idServicio ||
                servicioSeleccionado.servicio.sucursalSeleccionada !==
                    idSucursal
        );

        this.calculaTotalServicios();
    }

    editarServicio(servicioSeleccionado: ServicioSeleccionado) {
        this.openDialogAgregarServicio(
            servicioSeleccionado.servicio,
            true,
            servicioSeleccionado.detalle
        );
    }

    getSucursal(idSucursal: number): SucursalPersonaDTO {
        return this.sucursales.filter(
            (sucursal) => sucursal.id === idSucursal
        )[0];
    }

    servicioDuplicado(idServicio: number, idSucursal: number): boolean {
        return (
            this.serviciosSeleccionados.filter(
                (servicioSeleccionado) =>
                    servicioSeleccionado.servicio.id === idServicio &&
                    servicioSeleccionado.servicio.sucursalSeleccionada ===
                        idSucursal
            ).length > 0
        );
    }

    editarServicioComplementario(event) {
        //console.log(event);

        this.openDialogAgregarServicioComplementario(event);
    }

    openDialogAgregarServicioComplementario(event) {
        const { servicioComplementario, editar, idx, archivo } = event;
        //console.log(event);
        const dialogRef = this.dialog.open(
            DialogAgregarServicioComplementarioComponent,
            {
                panelClass: "clase-dialog",
                data: {
                    servicioComplementario,
                    sucursales: this.sucursales,
                    archivo,
                    editar,
                },
                width: "600px",
            }
        );

        dialogRef
            .afterClosed()

            .subscribe((result) => {
                //console.log("Dialog result:", result);
                if (result) {
                    if (editar) {
                        //console.log(idx);
                        this.quitarServicioComplementario(idx);
                        this.agregarServicioComplementario(result);
                    } else {
                        this.agregarServicioComplementario(result);
                    }
                }
            });
    }

    agregarServicioComplementario(data) {
        //console.log(data);
        const sucursal = this.getSucursal(data.form.sucursal);
        const servicioComp = {
            nombre: "Servicio Complementario",
            observacion: data.form.observacion,
            sucursal: data.form.sucursal,
            nombreSucursal: this.armaNombreSucursal(sucursal),
            filename: data.archivo?.name,
        };
        this.serviciosComplementarios.servicios.push(servicioComp);
        //console.log("archivo", data.archivo);

        this.serviciosComplementarios.archivos.push(data.archivo);

        //console.log(this.serviciosComplementarios);
    }

    quitarServicioComplementario(index: number) {
        this.serviciosComplementarios.servicios.splice(index, 1);
        this.serviciosComplementarios.archivos.splice(index, 1);
    }

    armaNombreSucursal(sucursal: SucursalPersonaDTO) {
        return `${sucursal.nombre} - ${sucursal.direccion}, ${sucursal.comuna.nombre}`;
    }

    solicitarCotizacion() {
        this.procesando=true;
        this._fuseProgressBarService.show();
        
        try{
            const serviciosSolicitados: ServicioSolicitadoDTO[] = [];
            this.serviciosSeleccionados.forEach((servicioSeleccionado) => {
                const { id, sucursalSeleccionada } = servicioSeleccionado.servicio;
                const {
                    cantidad,
                    condicion,
                    observacion,
                    tiempo,
                } = servicioSeleccionado.detalle;

                const servicioSolicitado = new ServicioSolicitadoDTO(
                    sucursalSeleccionada,
                    id,
                    condicion,
                    cantidad,
                    tiempo,
                    observacion,
                    null
                );
                serviciosSolicitados.push(servicioSolicitado);
            });
            this.serviciosComplementarios.servicios.forEach(
                (servicioComplementario) => {
                    const {
                        observacion,
                        sucursal,
                        filename,
                    } = servicioComplementario;

                    const servicioSolicitado = new ServicioSolicitadoDTO(
                        sucursal,
                        0,
                        null,
                        null,
                        null,
                        observacion,
                        filename
                    );
                    serviciosSolicitados.push(servicioSolicitado);
                }
            );
            
            const formData = this.toFormData(
                serviciosSolicitados,
                this.serviciosComplementarios.archivos
            );

            this.subscripciones.add(
                this._cotizacionesSrvc
                    .generaSolicitudCotizacion(formData)
                        .pipe(finalize(()=>{
                            this._fuseProgressBarService.hide();
                            this.procesando=false;
                        }))
                        .subscribe((resp) => {
                            this._notificacionesSrvc.mostrarNotificacion(
                                "Solicitud de Cotización enviada",
                                "success"
                            );
                            this.router.navigateByUrl("cotizaciones");
                        })
            );
            
        }
        catch(e){
            this._fuseProgressBarService.hide();
            this.procesando=false;
        }   
    }

    toFormData<T>(
        serviciosSolicitados: ServicioSolicitadoDTO[],
        archivos: File[]
    ) {
        const formData = new FormData();
        formData.append("servicios", JSON.stringify(serviciosSolicitados));
 
        archivos.forEach((archivo) => {
            if (archivo) {
                formData.append("archivos", archivo, archivo.name);
            }
        });

        return formData;
    }

    ngOnDestroy() {
        this.subscripciones.unsubscribe();
    }
}
